export default {
    props: {
        cancelOperationUrl: {
            type: String,
            required: false,
        },
    },
};
